var worksRelatedWorksCountRouteHelper = window.worksRelatedWorksCountRouteHelper;
var workViewCountsRouteHelper = window.workViewCountsRouteHelper;
var workRelatedWorksRouteHelper = window.workRelatedWorksRouteHelper;
var workPercentilesRouteHelper = window.workPercentilesRouteHelper;
var workMentionsCountRouteHelper = window.workMentionsCountRouteHelper;
var workCitationsCountRouteHelper = window.workCitationsCountRouteHelper;
var workCertificationCountsRouteHelper = window.workCertificationCountsRouteHelper;
var workBookmarkCountsRouteHelper = window.workBookmarkCountsRouteHelper;
var userRelationStatsHelper = window.userRelationStatsHelper;
var socialDistanceRouteHelper = window.socialDistanceRouteHelper;
var postDownloadDataHelper = window.postDownloadDataHelper;
var paperRanksRouteHelper = window.paperRanksRouteHelper;
var authorRanksRouteHelper = window.authorRanksRouteHelper;
var AsynchronousItemDataFetcher = window.AsynchronousItemDataFetcher;
var AsynchronousItemDataFetcher, authorRanksRouteHelper, paperRanksRouteHelper, postDownloadDataHelper, socialDistanceRouteHelper, userRelationStatsHelper, workBookmarkCountsRouteHelper, workCertificationCountsRouteHelper, workCitationsCountRouteHelper, workMentionsCountRouteHelper, workPercentilesRouteHelper, workRelatedWorksRouteHelper, workViewCountsRouteHelper, worksRelatedWorksCountRouteHelper;
AsynchronousItemDataFetcher = function () {
  function AsynchronousItemDataFetcher(routeHelper, ajaxResponseDataKey) {
    this.routeHelper = routeHelper;
    this.ajaxResponseDataKey = ajaxResponseDataKey;
    this.pendingItems = [];
    this.retrieve = _.debounce(this.retrievePendingItems, 100);
  }
  AsynchronousItemDataFetcher.prototype.queue = function (itemId, callback) {
    this.pendingItems.push({
      itemId: itemId,
      callback: callback
    });
    return this.retrieve();
  };
  AsynchronousItemDataFetcher.prototype.retrievePendingItems = function () {
    var itemIds, itemsCopy;
    if (this.pendingItems.length === 0) {
      return;
    }
    itemsCopy = this.pendingItems.slice();
    itemIds = _.keys(_.groupBy(this.pendingItems, 'itemId'));
    this.pendingItems = [];
    return $.ajax({
      dataType: 'jsonp',
      url: this.routeHelper(itemIds),
      success: function (_this) {
        return function (data) {
          return _.each(data[_this.ajaxResponseDataKey], function (itemAttribute, itemId) {
            var matchingItems;
            itemId = parseInt(itemId);
            matchingItems = _.filter(itemsCopy, function (itemInItemsCopy) {
              return itemInItemsCopy.itemId === itemId;
            });
            return _.each(matchingItems, function (item) {
              return item.callback(itemAttribute);
            });
          });
        };
      }(this)
    });
  };
  return AsynchronousItemDataFetcher;
}();
workViewCountsRouteHelper = function (workIds) {
  return $r.api_v0_works_views_url({
    work_ids: workIds
  });
};
window.Academia.workViewCountsFetcher = new AsynchronousItemDataFetcher(workViewCountsRouteHelper, 'views');
workPercentilesRouteHelper = function (workIds) {
  return $r.api_v0_works_percentiles_url({
    work_ids: workIds
  });
};
window.Academia.workPercentilesFetcher = new AsynchronousItemDataFetcher(workPercentilesRouteHelper, 'percentiles');
workCertificationCountsRouteHelper = function (workIds) {
  return $r.api_v0_works_certification_counts_url({
    work_ids: workIds
  });
};
window.Academia.workCertificationCountsFetcher = new AsynchronousItemDataFetcher(workCertificationCountsRouteHelper, 'certification_counts');
workBookmarkCountsRouteHelper = function (workIds) {
  return $r.api_v0_works_bookmark_counts_url({
    work_ids: workIds
  });
};
window.Academia.workBookmarkCountsFetcher = new AsynchronousItemDataFetcher(workBookmarkCountsRouteHelper, 'bookmark_counts');
workMentionsCountRouteHelper = function (workIds) {
  return $r.work_mentions_count_api_v0_mentions_url({
    work_ids: workIds,
    viewed_user_id: Aedu.User.viewed.id
  });
};
window.Academia.workMentionsCountsFetcher = new AsynchronousItemDataFetcher(workMentionsCountRouteHelper, 'work_mention_counts');
workCitationsCountRouteHelper = function (workIds) {
  return $r.work_citations_count_api_v0_mentions_url({
    work_ids: workIds,
    viewed_user_id: Aedu.User.viewed.id
  });
};
window.Academia.workCitationsCountsFetcher = new AsynchronousItemDataFetcher(workCitationsCountRouteHelper, 'work_citation_counts');
workRelatedWorksRouteHelper = function (workIds) {
  return $r.api_v0_works_related_works_url({
    work_ids: workIds
  });
};
window.Academia.workRelatedWorksFetcher = new AsynchronousItemDataFetcher(workRelatedWorksRouteHelper, 'related_works');
worksRelatedWorksCountRouteHelper = function (workIds) {
  return $r.counts_api_v0_works_related_works_url({
    work_ids: workIds
  });
};
window.Academia.worksRelatedWorksCountFetcher = new AsynchronousItemDataFetcher(worksRelatedWorksCountRouteHelper, 'related_works_counts');
paperRanksRouteHelper = function (workIds) {
  return $r.api_v0_certifications_ranks_paper_ranks_url({
    ids: workIds
  });
};
window.Academia.paperRanksFetcher = new AsynchronousItemDataFetcher(paperRanksRouteHelper, 'paper_ranks');
authorRanksRouteHelper = function (userIds) {
  return $r.api_v0_certifications_ranks_author_ranks_url({
    ids: userIds
  });
};
window.Academia.authorRanksFetcher = new AsynchronousItemDataFetcher(authorRanksRouteHelper, 'author_ranks');
socialDistanceRouteHelper = function (workIds) {
  return $r.api_v0_social_distance_url() + '?work_ids[]=' + workIds.join('&work_ids[]=');
};
window.Academia.socialDistanceFetcher = new AsynchronousItemDataFetcher(socialDistanceRouteHelper, 'works');
userRelationStatsHelper = function (userIds) {
  return $r.api_v0_profiles_user_relation_stats_url({
    ids: userIds
  });
};
window.Academia.userRelationStats = new AsynchronousItemDataFetcher(userRelationStatsHelper, 'profile_user_relation_stats');
postDownloadDataHelper = function (attachmentIds) {
  return $r.api_v0_post_download_data_url({
    ids: attachmentIds
  });
};
window.Academia.postDownloadDataFetcher = new AsynchronousItemDataFetcher(postDownloadDataHelper, 'post_download_data');
window.AsynchronousItemDataFetcher = AsynchronousItemDataFetcher;
window.authorRanksRouteHelper = authorRanksRouteHelper;
window.paperRanksRouteHelper = paperRanksRouteHelper;
window.postDownloadDataHelper = postDownloadDataHelper;
window.socialDistanceRouteHelper = socialDistanceRouteHelper;
window.userRelationStatsHelper = userRelationStatsHelper;
window.workBookmarkCountsRouteHelper = workBookmarkCountsRouteHelper;
window.workCertificationCountsRouteHelper = workCertificationCountsRouteHelper;
window.workCitationsCountRouteHelper = workCitationsCountRouteHelper;
window.workMentionsCountRouteHelper = workMentionsCountRouteHelper;
window.workPercentilesRouteHelper = workPercentilesRouteHelper;
window.workRelatedWorksRouteHelper = workRelatedWorksRouteHelper;
window.workViewCountsRouteHelper = workViewCountsRouteHelper;
window.worksRelatedWorksCountRouteHelper = worksRelatedWorksCountRouteHelper;